<p class="text-title-lgx-bold">¡Casi terminamos!</p>
<p class="text-info-bold-xs mt-xxs mb-xlg">POR FAVOR RESPONDE LA PREGUNTA</p>

<form nz-row novalidate
  #form="ngForm">
  <div nz-col nzSpan="24">
    <!--Content-->
    <div class="address-container mb-sm">
      <div class="tw-w-full">
        <div class="text-info-upper mb-xs">¿Cómo se enteró de la clínica?</div>
        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Seleccione" [required]="true" [(ngModel)]="reason" #ngReason="ngModel" name="reason">
          <nz-option *ngFor="let reason of optionsReason;" [nzLabel]="reason" [nzValue]="reason"></nz-option>
        </nz-select>
        <app-message-field [field]="ngReason"></app-message-field>
      </div>
    </div>
    <!-- / Content-->
  </div>
</form>
